import { render, staticRenderFns } from "./ConversationsNotification.vue?vue&type=template&id=067a15d1&"
import script from "./ConversationsNotification.vue?vue&type=script&lang=js&"
export * from "./ConversationsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports